import { useEffect } from 'react';
import { useSourContext } from '@wayste/sour-context';
import { isSupportedApplication } from '../utils';
import { useTaskBoardStore } from './store';
/**
 * Hook for using the task board with context awareness
 * - Initializes application context
 * - Handles error logging
 * - Provides access to the store with proper typing
 */
export const useTaskBoard = () => {
    const { application } = useSourContext();
    const store = useTaskBoardStore();
    const { setApplication, error } = store;
    // Verify application is supported
    if (!isSupportedApplication(application)) {
        throw new Error(`Unsupported application: ${application}`);
    }
    // Set up application in the store
    useEffect(() => {
        if (application) {
            setApplication(application);
        }
    }, [application, setApplication]);
    // Log errors
    useEffect(() => {
        if (error) {
            console.error('Task board error:', error);
        }
    }, [error]);
    // Return the store directly
    return store;
};
export default useTaskBoard;
//# sourceMappingURL=use-task-board.js.map